namespace RioERP.Reports {
    @Serenity.Decorators.registerClass()
    export class AddBookDialog extends Serenity.EntityDialog<OrderShippingReportRow, any> {
        loadedState: string;
        protected getFormKey() { return "Reports.AddBook"; }
        protected form = new AddBookForm(this.idPrefix);
        private orderId: string;

        constructor(orderId: string) {
            super();
            this.orderId = orderId;
            this.dialogTitle = "Scan and Add Book";
        }

        protected getDialogTitle(): string {
            return "Scan And Add Book";
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            // Set the OrderNumber value in the form
            this.form.OrderId.value = this.orderId.toString(); // Ensure it's a string
        }

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [
                {
                    text: 'Add Book',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (Q.isEmptyOrNull(this.form.BookIsbn.value)) {
                            Q.notifyError("Please enter the ISBN!");
                            return;
                        }

                        OrderShippingReportService.ScanBook({
                            BookIsbn: this.form.BookIsbn.value,
                            OrderId: this.orderId, // Use the orderId directly
                        }, (response: Serenity.ServiceResponse) => {
                            if (response.Error) {
                                Q.notifyError(response.Error.Message);
                            } else {
                                Q.notifyInfo('Book successfully added.');
                                this.dialogClose();
                                location.reload();
                            }
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}
